module.exports = "/images/bell-module.svg?16acb67958aae1882af5676db9c1a549";